<template>
  <label
    :for="id"
    class="flex justify-start items-center cursor-pointer"
  >
    <div
      v-if="label && labelFirst"
      class="label mt-1 mr-2"
    >
      <p data-test="label-before">
        <label :for="id">
          {{ label }}
        </label>
      </p>
    </div>
    <div class="flex justify-start relative">
      <input
        :id="id"
        type="checkbox"
        class="sr-only"
        @input="$emit('input', $event.target.checked)"
        :checked="value"
        :aria-checked="value"
        role="switch"
        data-test="input"
      />
      <div class="block w-12 h-7 bg-gray-200 rounded-full shadow-inner" />
      <div
        class="dot absolute left-1 top-1 bg-signablePrimary1 w-5 h-5 rounded-full shadow-inner border-solid border-1 border-signablePrimary1Shade2 tw-transform-linear"
      />
    </div>
    <div
      v-if="label && !labelFirst"
      class="label mt-1 ml-2"
    >
      <p data-test="label-after">
        <label :for="id">
          {{ label }}
        </label>
        </p>
    </div>
  </label>
</template>

<script>
export default {
  name: 'ToggleInput',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    labelFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
input:checked ~ .block {
  @apply bg-success;
}
input:checked ~ .dot {
  @apply tw-translate-x-100 bg-light border-white;
}
</style>
